import React from "react";
import { Navigate } from "react-router-dom";

// Notas de crédito se movieron a /sri/credit-notes — estas rutas se dejan
// como redirect para no romper enlaces/bookmarks viejos a /finanzas/credit-note/*.
export const creditNoteRoutes = [
  {
    path: "add",
    element: <Navigate replace to="/sri/credit-notes/add" />,
  },
  {
    path: "list",
    element: <Navigate replace to="/sri/credit-notes/issued" />,
  },
  {
    path: "",
    element: <Navigate replace to="/sri/credit-notes/issued" />,
  },
];
